import React from 'react';
import { ReactComponent as Export } from '../../assets/images/icons/export.svg';

export default function ExportIcon({ className }) {
  return (
    <Export className={`icon ${className}`} />
  );
}
